import React, { Component } from 'react';
import { Big3Common } from '../../js/IncludeManager';
import { GoodsPhoto, ComPhoto, BookMarkStore } from '../../js/ComponentManager'
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import 'swiper/css/thumbs';

/* 개발담당:양유빈
 * 화면기능:리스트 도매
 * 세부설명:
*/

export class ListWhole extends Component {
    static displayName = ListWhole.name;

    constructor(props) {
        super(props);
        this.state = {
            ContentConmgr: { ...this.DataObject.ContentConmgr },
            TotalCount: 0,
            WholeList: [],
            WholetoGoods:[],
            Bgcolor: ""
        };
        this.handleGoodsDtl_Click = this.handleGoodsDtl_Click.bind(this);
        this.handleAddMore_Click = this.handleAddMore_Click.bind(this);
        this.index = -1;
    }
    //초기화
    componentDidMount() {
        const ContentConmgr = Big3Common.Util.GetContentState(this.props, "data-info", null);
        this.index = Big3Common.Util.GetContentState(this.props, "index", -1);
        if (ContentConmgr !== null) {
            this.setState({ ContentConmgr: ContentConmgr }, () => {
                this.GetMainWholeList();
            });
        }
    }
    DataObject = {
        ContentConmgr: {
            mgr_no: "",
            title: "",
            cntt_tye: "",
            fltr_tye: "",
            ui_tye: "",
            width_cnt: "",
            len_cnt: "",
            tab_use_yn: ""  //스와이프에서 탭은 미적용
        }
    }
    SearchModel = {
        Page_Number: 1,
        Page_Size: 6,
        mgr_no: 0,
        fltr_tye: "MA"
    }
    GetMainWholeList = async () => {
        try {

            this.SearchModel.Page_Size = (parseInt(this.state.ContentConmgr.width_cnt) * this.state.ContentConmgr.len_cnt);
            this.SearchModel.mgr_no = this.state.ContentConmgr.mgr_no;
            const Data = await Big3Common.Post("api/AdMgr/HomeAd/GetMainSettingList",
                this.SearchModel, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {
                const multiDataTable = JSON.parse(Data.multiDataTable);
                const DataList = multiDataTable.goodsList;
                const GoodsList = multiDataTable.wholetogoods;

                const Bgcolor = multiDataTable.bgcolor;
                const TotalCount = (this.SearchModel.Page_Number * this.SearchModel.Page_Size);
                let WholeListPush = this.state.WholeList;
                DataList.map(list => WholeListPush.push(list));

                const WholetogoodsPush = this.state.WholetoGoods;
                GoodsList.map(list => WholetogoodsPush.push(list));

                this.setState({
                    WholeList: WholeListPush,
                    TotalCount: TotalCount,
                    Bgcolor: Bgcolor,
                    WholetoGoods: WholetogoodsPush
                });
            }
            else {
                console.log(Data.message, `${this.SearchModel.mgr_no}번`);
            }
        }
        catch (e) {
            console.log("GetMainWholeList", e);
        }
    }
    handleGoodsDtl_Click = async (event, goods_no, uid) => {
        const GoodsDtlShow = this.props.GoodsDtlShow;
        const mgr_no = this.state.ContentConmgr.mgr_no;
        if (GoodsDtlShow !== undefined && GoodsDtlShow !== null) {
            GoodsDtlShow(goods_no, uid, mgr_no);
        }
        event.preventDefault();
    }
    handleAddMore_Click() {
        this.SearchModel.Page_Number++;
        this.GetMainWholeList();
    }
    //매장상품 리스트
    Whole_Goods_render(uid) {
        const SlidersCount = Big3Common.WebConfig.SlidersCount;
        const wholetogoods = this.state.WholetoGoods.filter(list => list.uid === uid);
        return (
            <Swiper watchSlidesProgress={true} slidesPerView={SlidersCount} className="today_poroducts row row-cols-3 no_line">
                <div>
                    {
                        wholetogoods.map((list, idx) =>
                            <SwiperSlide key={`${idx}_${list.uid}_${list.goods_no}`} className="product"
                                onClick={(e) => { this.handleGoodsDtl_Click(e, list.goods_no, list.uid) }}
                            >
                                <GoodsPhoto className="product_img" ImageSrc={list.img_220}
                                    BackGround={true}
                                >
                                </GoodsPhoto>
                                <div className="wh_product_info">
                                    <div className="wh_product_title">{list.goods_nm }</div>
                                    <div className="wh_product_price">{list.strqst_yn === "Y" ? "매장문의" : `${Big3Common.Util.Money(list.goods_price)}원`}</div>
                                </div>
                            </SwiperSlide>
                        )}
                </div>
                <SwiperSlide>
                    {/* 공백*/}
                </SwiperSlide>
            </Swiper>
        )
    }

    //매장사진
    Photo_render(list) {
        if (list.photo === null) {
            return (
                <GoodsPhoto
                    className="wh_shop_img"
                    ImageSrc={list.img_220}
                />
            )
        }
        else {
            return (
                <ComPhoto
                    className="wh_shop_img"
                    Photo={list.photo}
                />
            )
        }
    }
    //매장정보
    Whole_render() {
        const WholeList = this.state.WholeList;
        return (
            WholeList.map((list) =>
                <div className="wh_shop" key={list.uid }>
                    <div className="wh_shop_info_box">
                        <Link to={`/Search/Goods/Index?Uid=${list.uid}`}>
                            {this.Photo_render(list)}
                        </Link>
                        <div className="wh_shop_info">
                            <div className="wh_shop_title">{list.whole_name}</div>
                            <div className="wh_shop_address">{`${list.bld_name} ${list.flr_name}층 ${list.whole_no_name}호`}</div>
                        </div>
                        <BookMarkStore
                            CheckCss="zzim_checked"
                            UnCheckCss="zzim"
                            Whole_Code={list.whole_code}
                            HeartOn={list.bookmark_store_yn === "Y" ? true : false}
                        />
                    </div>
                    {this.Whole_Goods_render(list.uid)}
                </div>
            )
        )
    }
    render() {

        if (this.state.WholeList.length === 0) return false;
        const Css = `main_content ${this.state.Bgcolor}`
        const Whole_render = this.Whole_render()
        return (
            <div className={Css}>
                <div className="rt_main_title_box">
                    <div className="title2">{Big3Common.Util.GetContentState(this.state.ContentConmgr, "title", "")}</div>
                </div>
                {Whole_render}
                {this.state.TotalCount === this.state.WholeList.length ? <div className="more_btn_box2"><button className="more_btn2" onClick={this.handleAddMore_Click}>더 보기</button></div> : ""}
            </div>   

        );
    }
}
